import React, { useEffect } from 'react';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig, validateAuthConfig } from "./authConfig";

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Handle the redirect callbacks
const handleRedirectPromise = () => {
    msalInstance.handleRedirectPromise().catch(error => {
        console.error("Redirect error:", error);
    });
};

// Call handleRedirectPromise before rendering the app
handleRedirectPromise();

// Add event callback for handling redirects
msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS) {
        console.log("Login Success");
    }
    if (event.eventType === EventType.LOGIN_FAILURE) {
        console.error("Login Failure", event.error);
    }
});

export const AuthProvider = ({ children }) => {
    useEffect(() => {
        // Handle redirect after page loads
        handleRedirectPromise();
        
        // Validate configuration on mount
        if (!validateAuthConfig()) {
            console.error('Authentication configuration is invalid. Please check your environment variables.');
        }
    }, []);

    return (
        <MsalProvider instance={msalInstance}>
            {children}
        </MsalProvider>
    );
}; 